var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.6H8V1.8H6V3.6ZM7 9C5.73333 9 4.525 8.7636 3.375 8.2908C2.225 7.818 1.1 7.2894 0 6.705V5.4C0 4.905 0.196 4.4814 0.588 4.1292C0.98 3.777 1.45067 3.6006 2 3.6H4V0.9C4 0.645 4.096 0.4314 4.288 0.2592C4.48 0.0870001 4.71733 0.0006 5 0H9C9.28333 0 9.521 0.0864001 9.713 0.2592C9.905 0.432 10.0007 0.6456 10 0.9V3.6H12C12.55 3.6 13.021 3.7764 13.413 4.1292C13.805 4.482 14.0007 4.9056 14 5.4V6.705C12.9 7.29 11.775 7.8189 10.625 8.2917C9.475 8.7645 8.26667 9.0006 7 9ZM2 18V17.1C1.45 17.1 0.979333 16.9239 0.588 16.5717C0.196666 16.2195 0.000666667 15.7956 0 15.3V8.73C0.933333 9.24 1.896 9.675 2.888 10.035C3.88 10.395 4.91733 10.635 6 10.755V11.7H8V10.755C9.08333 10.635 10.121 10.395 11.113 10.035C12.105 9.675 13.0673 9.24 14 8.73V15.3C14 15.795 13.8043 16.2189 13.413 16.5717C13.0217 16.9245 12.5507 17.1006 12 17.1V18H10V17.1H4V18H2Z",
    fill: "#000636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.43b457f87e523799f1450273250bbdf3.svg";
export { ForwardRef as ReactComponent };